<template>
    <div class="bi-content">
        <div class="bi-content-top">
            <div class="opera-tit-btn">
                <div class="tit">{{biConfigData.modelTit}}</div>
                <div class="btn"><el-button type="primary" @click="saveData">保存数据</el-button></div>
            </div>
            <div class="form-data">
                <el-form class="float:left" size="mini" label-width="100px">
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="模型名称">
                                <el-input placeholder="请输入内容" v-model.trim="modelData.modelName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="模型描述">
                                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="modelData.remarks" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4">
                          <el-form-item label="数据来源">
                                <el-radio v-model="BIDimension" :label="0" @change="initFormList" :disabled="canChoose">表单</el-radio>
                                <el-radio v-model="BIDimension" :label="2" @change="initFormList" :disabled="canChoose">报表</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="数据模型">
                                 <TreeSelect
                                     placeholder="请选择模型"
                                     ref="treeSelect"
                                     :multiple="false"
                                     :disableBranchNodes="true"
                                     :sourceOptions="appModelsOptions"
                                     @treeSelectChoose="treeSelectChoose"
                                 />
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                          <el-form-item label="维度">
                               <el-select v-model="selectXdata" :disabled="isCanSelect" clearable placeholder="请选择X轴数据字段" @change="changeXdata"  style="width: 100%;">
                                   <el-option-group
                                     v-for="(item, index) in XData"
                                     :key="index"
                                     :label="item.name">
                                     <el-option
                                         v-for="(cur, curIndex) in item.options"
                                         :key="curIndex"
                                         :label="BIDimension === 2 ? '【' + cur.formName + '】' + cur.name : cur.name"
                                         :value="cur.id"
                                     >
                                     </el-option>
                                   </el-option-group>
                               </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="指标">
                              <el-select
                                  v-model="selectYdata"
                                  :disabled="isCanSelect"
                                  value-key="id"
                                  clearable
                                  placeholder="请选择Y轴数据字段"
                                  @change="changeYdata"
                                  :multiple="yIsmultiple"
                                  style="width: 100%;"
                              >
                              <el-option-group
                                v-for="(item, index) in YData"
                                :key="index"
                                :label="item.name">
                                <el-option
                                    v-for="(cur, curIndex) in item.options"
                                    :key="curIndex"
                                    :label="BIDimension === 2 ? '【' + cur.formName + '】' + cur.name : cur.name"
                                    :value="cur.id"
                                >
                                </el-option>
                              </el-option-group>
                              </el-select>
                          </el-form-item>
                        </el-col>
                     </el-row>
                     <el-row v-if="allChooseYdata.length>0">
                        <div class="zb-item" v-for="(item,index) in allChooseYdata" :key="index">
                            <div class="item-field"><span class="field-name-border">【</span>
                                <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                  <span class="field-name">{{item.name}}</span>
                                </el-tooltip>
                            <span class="field-name">】</span></div>
                            <div class="item-calcul">
                                <el-select v-model="item.calculVal"  value-key="id" placeholder="对Y轴数据进行处理" @change="changeOpreaYdata">
                                    <el-option v-for="item in opreaYdata" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                            <div class="item-alias">
                                <el-input v-model.trim="item.alias" placeholder="设置字段显示别名(可选)"></el-input>
                            </div>
                        </div>
                     </el-row>
                     <el-row>
                        <div class="bi-type">
                            <div class="bi-tit">
                                BI类型
                            </div>
                            <div class="bi-type-item">
                                <svg t="1602815861549" class="icon" :class="{ active: chartType == 1 }" @click="showData(1)" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4826" width="200" height="200"><path d="M153.6 307.2h153.6v665.6H153.6zM563.2 409.6h153.6v563.2h-153.6z" fill="#698FE1" p-id="4827"></path><path d="M307.2 102.4h153.6v870.4H307.2zM716.8 665.6h153.6v307.2h-153.6z" fill="#2FC25B" p-id="4828"></path><path d="M0 0v1024h1024v-66.304H64V0z" fill="#698FE1" p-id="4829"></path></svg>
                            </div>
                            <div class="bi-type-item">
                               <svg t="1602815549915"  class="icon" :class="{ active: chartType == 2 }" @click="showData(2)" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4684" width="200" height="200"><path d="M78.101695 513.700881a460.921492 459.932203 90 1 0 919.864407 0 460.921492 459.932203 90 1 0-919.864407 0Z" fill="#4093FF" p-id="4685"></path><path d="M886.037695 212.263051C719.056271 20.132881 428.240271-0.520678 236.526644 166.113627 44.830373 332.782644 24.818983 623.598644 191.817763 815.728814" fill="#25C7C1" p-id="4686"></path><path d="M536.48922 0v519.549831L928.542373 839.905627C834.907119 952.424136 694.029017 1024 536.48922 1024 254.576814 1024 26.033898 794.762847 26.033898 512S254.576814 0 536.48922 0z" fill="#F47353" p-id="4687"></path></svg>
                            </div>
                            <div class="bi-type-item">
                                <svg t="1602816678231" class="icon" :class="{ active: chartType == 3 }" @click="showData(3)" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4680" width="200" height="200"><path d="M512 78.2555404v176.74762534H99.58887373V78.2555404z" fill="#5AD8A6" p-id="4681"></path><path d="M983.32700047 313.91904133v176.74762534H99.58887373V313.91904133z" fill="#5B8FF9" p-id="4682"></path><path d="M688.74762534 549.58254224v176.74762536H99.58887373v-176.74762536z" fill="#5AD8A6" p-id="4683"></path><path d="M394.16825023 785.2460418v176.74762534H99.58887373v-176.74762534z" fill="#5B8FF9" p-id="4684"></path></svg>
                            </div>
                            <div class="bi-type-item">
                                <svg t="1602815927031" class="icon" :class="{ active: chartType == 4 }" @click="showData(4)" viewBox="0 0 1279 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5111" width="200" height="200"><path d="M154.512796 793.19994a36.571076 36.571076 0 1 1-53.02806-50.394943l694.850442-731.421518a36.571076 36.571076 0 0 1 55.661178 3.145112l402.281835 531.560589a36.571076 36.571076 0 0 1-58.294295 44.141288L819.667525 93.01012 154.549367 793.19994z" fill="#78EBB9" p-id="5112"></path><path d="M454.212763 108.918538l-301.382237 278.561886a36.571076 36.571076 0 1 1-49.663521-53.759482l333.564784-308.29417a36.571076 36.571076 0 0 1 55.697748 7.314215l334.479061 527.135488L1197.081028 117.403028a36.571076 36.571076 0 0 1 56.100031 46.92069l-402.281836 480.836507a36.571076 36.571076 0 0 1-58.916003-3.876535L454.176192 108.918538z" fill="#617BCA" p-id="5113"></path><path d="M0 36.58095a18.285538 18.285538 0 1 1 36.571076 0v950.847974a18.285538 18.285538 0 1 1-36.571076 0V36.58095z" fill="#DADADA" p-id="5114"></path><path d="M18.285538 1005.714462a18.285538 18.285538 0 1 1 0-36.571076h1206.845505a18.285538 18.285538 0 1 1 0 36.571076H18.285538z" fill="#DADADA" p-id="5115"></path></svg>
                            </div>
                            <div class="bi-type-item">
                                <svg t="1602816651890" class="icon" :class="{ active: chartType == 5 }" @click="showData(5)" viewBox="0 0 1604 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4538" width="200" height="200"><path d="M846.4763493 49.30729967c265.90245515 33.22678138 401.53122857 227.30797878 401.53122859 462.69270033 0 61.14887004-9.32416308 119.65169461-30.58073435 172.84982647l231.32744921 134.28055039c42.57614474-93.07782895 63.8201174-198.10066779 63.82011738-307.13037686 0-382.9081027-267.25067818-698.02701973-666.12326112-731.26640127l0.02520029 268.57370094z" fill="#61BE66" p-id="4539"></path><path d="M713.51882166 974.69270033C514.09513111 941.44071711 315.89366065 747.33431939 315.89366065 512s198.10066779-429.46591738 397.62516101-462.69270033V-219.26640127c-332.40641846 33.25198166-662.14159116 348.35829857-662.14159115 731.26640127s329.73517268 698.02701973 662.14159115 731.26640127v-268.57370094z" fill="#108CEE" p-id="4540"></path><path d="M1149.61245607 800.50725099c-73.13168032 93.07782895-170.17857911 155.54972333-303.16130706 174.18544934v268.58630108c199.43629069-19.94614863 410.8427915-136.95179774 530.51968642-308.50380017l-227.35837936-134.26795025z" fill="#FFC700" p-id="4541"></path></svg>
                            </div>

                            <div class="bi-datasource-tit">
                                是否展示数据源
                            </div>
                            <div class="bi-datasource-data">
                                <el-radio-group v-model="showDataSource">
                                    <el-radio-button label="0">否</el-radio-button>
                                    <el-radio-button label="1">是</el-radio-button>
                                </el-radio-group>
                            </div>

                            <div class="bi-datasource-tit">
                                是否二纬展示数据
                            </div>
                            <div class="bi-datasource-data">
                                <el-radio-group v-model="showBiWay">
                                    <el-radio-button label="0">否</el-radio-button>
                                    <el-radio-button label="1">是</el-radio-button>
                                </el-radio-group>
                            </div>

                            <div class="bi-datasource-data">
                                <el-button type="success" @click="showBiSearch">数据过滤条件</el-button>
                            </div>
                        </div>
                     </el-row>
                </el-form>
            </div>
        </div>
        <div class="bi-content-main">
            <DashBoard ref="dashBoardRefs" :chartType="chartType" :chartData="chartData" :chartSettings="chartSettings" :showSearch="false" />
        </div>

        <!-- 侧滑搜索区域 -->
        <el-drawer
          :visible.sync="isShowBiSearchSetting"
          title="配置搜索条件"
          :direction="direction"
          size="25vw"
            >
             <div class="search-field" style="height: 100%;">
                 <SearchCondition
                     ref="searchConditon"
                     :key="searchLoadTimer"
                     :isShowLeftModel="false"
                     :conditionFields="conditionFields"
                     :class="'search-field-box'"
                     :style="'height:82vh;overflow:auto;'"
                     >
                 </SearchCondition>
             </div>
             <div class="opt" style="position: fixed;bottom: 20px;text-align: center;left: 7vw;">
                 <el-button @click="celSetForm">取消</el-button>
                 <el-button type="success" @click="subSetForm">确定</el-button>
             </div>
        </el-drawer>
    </div>
</template>

<script>
import DashBoard from '@/components/DashBoard';
import SearchConditionSide from '@/components/SearchCondition/SearchConditionSide';
import { getApplicationModelTreeList, getBIFormConfigs, getFormDashBoardConfig, getModelFormReportList, getFormFieldListByIds } from '@/data-model';
export default {
    name: 'BiConfig',
    comments: {
        DashBoard: DashBoard,
        SearchCondition: SearchConditionSide
    },
    props: {
        biConfigData: {
            type: Object,
            default: () => {
                return {
                    modelTit: '',
                    appId: '',
                    formId: '',
                    modelName: '',
                    remarks: '',
                    modelId: ''
                };
            }
        }
    },
    data () {
        return {
            modelData: {
                modelName: '',
                remarks: '',
                formIds: '',
                modelIds: '',
                id: '',
                formId: ''
            },
            searchLoadTimer: '',
            chartType: 1,
            appModelsOptions: [],
            XData: [],
            YData: [],
            searchData: [],
            opreaYdata: [{ id: 1, name: '原值显示' }, { id: 2, name: '计数统计' }, { id: 3, name: '加和统计' }, { id: 4, name: '平均统计' }],
            cakeData: [],
            selectXdata: '',
            selectYdata: '',
            selectSearchData: [],
            selectOpreaYdata: '',
            selectCakedata: '',
            isCanSelect: true,
            formData: {},
            chartData: {
                columns: ['数字类型字段1', '数字类型字段2'],
                rows: [
                    { 数字类型字段1: 10000, 数字类型字段2: 5000, dataName: '数据名称1' },
                    { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称2' },
                    { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称3' }
                ]
            },
            BIDimension: 0,
            chartSettings: {},
            dashboardSetting: {},
            dashboardData: {},
            modelId: '',
            allChooseXdata: [],
            allChooseYdata: [],
            formId: '',
            initData: 0,
            id: '',
            yIsmultiple: true,
            canChoose: false,
            showDataSource: '0',
            showBiWay: '0',
            isShowBiSearchSetting: false,
            direction: 'ltr',
            conditionFields: [],
            tableColumns: [],
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: '',
                formId: ''
            },
            formPage: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            },
            allFields: []
        };
    },
    created () {
        if (this.biConfigData.formId) {
            this.modelData.modelName = this.biConfigData.modelName;
            this.modelData.remarks = this.biConfigData.remarks;
            // 修改
            this.canChoose = true;
            this.eachBiData();
        } else {
            // 新增
            this._initPage();
        }
    },
    methods: {
        async _initPage (obj) {
            let modelTree = await getApplicationModelTreeList({
                currentPage: 1,
                pageSize: 100,
                state: 1,
                modelType: this.BIDimension
            });
            this.appModelsOptions = modelTree;
            if (!this.biConfigData.formId) {
                this.showData(1);
            } else {
                this.$refs.treeSelect.initParam(obj.dashBoardDataConfig.dataModelId);
                this.dashboardSetting = obj.chartSettings;
                this.dashboardData = obj.chartData;
                this.initData = 1;
                this.selectXdata = obj.dimensionIds;
                this.selectYdata = obj.metricsIds;
                this.allChooseXdata = obj.allChooseXdata[0];
                this.allChooseYdata = obj.allChooseYdata;
                this.modelId = obj.dashBoardDataConfig.modelId;
                this.selectOpreaYdata = obj.dashBoardDataConfig.showDataWay;
            }
        },
        initFormList () {
            this._initPage();
        },
        initSelectData () {
            this.selectXdata = '';
            this.selectYdata = '';
            this.selectCakedata = '';
        },
        showData (obj) {
            this.chartType = obj;
            if (obj === 2 || obj === 5) {
                this.chartData = {
                    metrics: ['数字类型字段1', '数字类型字段2'],
                    rows: [
                        { 数字类型字段1: 10000, 数字类型字段2: 5000, dataName: '数据名称1' },
                        { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称2' },
                        { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称3' }
                    ]
                };
                this.chartSettings = {
                    dimension: 'dataName',
                    metrics: '数字类型字段2'
                };
            } else {
                this.chartData = {
                    columns: ['数字类型字段1', '数字类型字段2'],
                    rows: [
                        { 数字类型字段1: 10000, 数字类型字段2: 5000, dataName: '数据名称1' },
                        { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称2' },
                        { 数字类型字段1: 8000, 数字类型字段2: 6000, dataName: '数据名称3' }
                    ]
                };
                this.chartSettings = {
                    metrics: ['数字类型字段1', '数字类型字段2'],
                    dimension: ['dataName']
                };
            }
        },
        dynamicBiData (e, type) {
            if (type === 1) {
                // x轴
                // 更新X轴的数据
                this.chartData.rows[0].dataName = e.name + '1';
                this.chartData.rows[1].dataName = e.name + '2';
                this.chartData.rows[2].dataName = e.name + '3';
            } else if (type === 2 || type === 5) {
                // Y轴
                this.chartSettings.metrics = [];
                for (var i = 0; i < e.length; i++) {
                    var name = e[i].name;
                    this.chartData.columns.push(name);
                    this.chartData.rows[0][name] = this.randomNum(1, 10000);
                    this.chartData.rows[1][name] = this.randomNum(1, 10000);
                    this.chartData.rows[2][name] = this.randomNum(1, 10000);
                    this.chartSettings.metrics.push(name);
                }
            }
        },
        treeSelectChoose (selected) {
            // 选择好数据源后
            if (selected) {
                this.formId = selected.formId;
                this.modelId = selected.id;
                this.initField(selected);
                if (this.initData === 0) {
                    this.initSelectData();
                } else {
                    this.initData = 0;
                }
            } else {
                this.formData = {};
                this.isCanSelect = true;
                this.selectXdata = '';
                this.selectYdata = '';
                this.searchData = '';
                this.showData(1);
            }
        },
        async initField (selected) {
            var param = { formId: selected.formId, BIDimension: this.BIDimension };
            let field = await getBIFormConfigs(param);
            let formArr = [];
            let formItem = {};
            let parArr = [];
            this.allFields = [];
            for (let i = 0; i < field.allList.length; i++) {
                let cur = field.allList[i];
                if (cur.type === 'subform') { // 子表单
                    let arr = cur.options.fieldList;
                    let sunArrId = cur.id;
                    let formChildArr = [];
                    for (let j = 0; j < arr.length; j++) {
                        let sunObj = arr[j];
                        sunObj.parentId = sunArrId;
                        sunObj.fieldType = 'childForm';
                        formChildArr.push(sunObj);
                        this.allFields.push(sunObj);
                    }
                    let sunName = cur.name;
                    let item = {};
                    item.name = sunName;
                    item.options = formChildArr;
                    formArr.push(item);
                } else { // 非子表单字段
                    cur.parentId = cur.id;
                    cur.fieldType = 'parentForm';
                    parArr.push(cur);
                    this.allFields.push(cur);
                }
            }
            formItem.name = '主表单字段';
            formItem.options = parArr;
            formArr.unshift(formItem);
            this.isCanSelect = false; // 解锁字段展现列表
            // this.XData = field.allList;
            this.XData = formArr;
            this.YData = formArr;
            this.searchData = field.allList;
            this.cakeData = field.allList;
            this.formData = selected;
        },
        changeXdata (e) {
            // 拿到X轴的数据,然后更新展示数据,目前X轴就一条数据后期多了再改造
            let list = this.allFields.find(i => i.id === e);
            let currentData = {id: e, name: list.name, type: list.type, fieldType: list.fieldType, parentId: list.parentId};
            this.allChooseXdata = currentData;
            this.dynamicBiData(currentData, 1);
        },
        changeYdata (e) {
            this.catchYData = this.allChooseYdata;
            this.allChooseYdata = [];
            if (e instanceof Array) {
                for (var j = 0; j < e.length; j++) {
                    let yobj = this.catchYData.find(y => y.id === e[j]);
                    if (yobj) {
                        this.allChooseYdata.push(yobj);
                    } else {
                        let list = this.allFields.find(i => i.id === e[j]);
                        let currentData = { id: e[j], name: list.name, type: list.type, calculVal: '', alias: '', fieldType: list.fieldType, parentId: list.parentId };
                        this.allChooseYdata.push(currentData);
                    }
                }
            } else {
                let list = this.YData.find(i => i.id === e);
                let currentData = { id: list.id, name: list.name, type: list.type, calculVal: '', alias: '' };
                this.allChooseYdata.push(currentData);
            }
            this.dynamicBiData(this.allChooseYdata, 2);
        },
        changeSearchData (e) {
        },
        messageTip (msg, type) {
            this.$message({
                message: msg,
                type: type,
                duration: 3000
            });
        },
        randomNum (m, n) {
            var num = Math.floor(Math.random() * (m - n) + n);
            return num;
        },
        buildParams () {
            // 参数统一在此构造
            let param = {};
            let dashboardSetting = {};
            dashboardSetting.metrics = [];
            dashboardSetting.metricsIds = [];
            dashboardSetting.metricsFieldType = [];
            dashboardSetting.dimension = [];
            dashboardSetting.dimensionIds = [];
            dashboardSetting.dimensionFieldType = [];
            dashboardSetting.calculVal = [];// 计算规则
            dashboardSetting.alias = [];// 别名
            dashboardSetting.dimensionParentId = [];
            dashboardSetting.dimensionFormType = [];
            dashboardSetting.metricsFormType = [];
            dashboardSetting.metricsParentId = [];
            dashboardSetting.dimension.push(this.allChooseXdata.name);
            dashboardSetting.dimensionIds.push(this.allChooseXdata.id);
            dashboardSetting.dimensionFieldType.push(this.allChooseXdata.type);
            dashboardSetting.dimensionParentId.push(this.allChooseXdata.parentId);
            dashboardSetting.dimensionFormType.push(this.allChooseXdata.fieldType);
            let dashboardData = {};
            dashboardData.columns = [this.allChooseXdata.name];
            dashboardData.columnsIds = [this.allChooseXdata.id];
            dashboardData.columnsFieldType = [this.allChooseXdata.type];
            for (var i = 0; i < this.allChooseYdata.length; i++) {
                var name = this.allChooseYdata[i].name;
                var id = this.allChooseYdata[i].id;
                var type = this.allChooseYdata[i].type;
                var formType = this.allChooseYdata[i].fieldType;
                var parentId = this.allChooseYdata[i].parentId;
                var calculVal = this.allChooseYdata[i].calculVal;// 计算规则
                if (!calculVal || calculVal === '') {
                    calculVal = 1;
                }
                var alias = this.allChooseYdata[i].alias;// 别名
                if (!alias || alias === '') {
                    alias = name;
                }
                if (this.allChooseXdata.name === alias) {
                    alias = alias + '数量';
                }
                dashboardSetting.metrics.push(name);
                dashboardSetting.metricsIds.push(id);
                dashboardSetting.metricsFieldType.push(type);
                dashboardSetting.metricsFormType.push(formType);
                dashboardSetting.metricsParentId.push(parentId);
                dashboardSetting.calculVal.push(calculVal);
                dashboardSetting.alias.push(alias);
                dashboardData.columns.push(name);
                dashboardData.columnsIds.push(id);
                dashboardData.columnsFieldType.push(type);
            }
            param.dashboardSetting = JSON.stringify(dashboardSetting);
            param.dashboardData = JSON.stringify(dashboardData);
            param.dashboardType = this.BIDimension;
            param.dataFormId = this.formId;
            param.dataModelId = this.modelId;
            param.dashboardShowType = this.chartType;
            param.showDataWay = this.selectOpreaYdata;
            param.showDataSource = this.showDataSource;
            param.showBiWay = this.showBiWay;
            param.id = this.id;
            return param;
        },
        async eachBiData () {
            this.isCanSelect = false;
            let formId = this.biConfigData.formId;
            let obj = await getFormDashBoardConfig(formId);
            this.BIDimension = obj.dashBoardDataConfig.dashboardType;
            this.chartSettings = obj.chartSettings;
            this.chartData = obj.chartData;
            this.id = obj.dashBoardDataConfig.id;
            this.showDataSource = obj.dashBoardDataConfig.showDataSource;
            // 回显BI类型
            this.chartType = obj.dashBoardDataConfig.dashboardShowType;
            this._initPage(obj);
        },
        changeOpreaYdata () {

        },
        async saveData () {
            if (this.modelData.modelName === undefined || this.modelData.modelName.trim() === '') {
                this.messageTip('请输入模型名称', 'warning');
                return;
            }
            let param = {};
            let biData = this.buildParams();
            param.formName = this.modelData.modelName;
            param.modelName = this.modelData.modelName;
            param.appName = this.biConfigData.modelTit;
            param.appId = this.biConfigData.appId;
            param.modelType = 3;
            param.biData = biData;
            param.remarks = this.modelData.remarks;
            param.id = this.biConfigData.formId;
            param.modelId = this.biConfigData.modelId;
            param.conditionFields = JSON.stringify(this.conditionFields);
            this.$emit('sendBiData', param);
        },
        showBiSearch () {
            let param = {dataModelId: this.modelId, dataFormId: this.formId};
            this.renderFormList(param, true, null);
            this.isShowBiSearchSetting = true;
        },
        celSetForm () {
            this.conditionFields = [];
            this.isShowBiSearchSetting = false;
        },
        subSetForm () {
            this.isShowBiSearchSetting = false;
        },
        async refreshSearchConditon (columns) {
            this.conditionFields.length = 0;
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            let cfs = await getFormFieldListByIds(idArr.join(','));
            this.conditionFields = [];
            if (cfs && cfs.length > 0) {
                for (var i = 0; i < cfs.length; i++) {
                    if (cfs[i].type === 'subform') {
                        continue;
                    } else {
                        this.conditionFields.push(cfs[i]);
                    }
                }
            }
            this.searchLoadTimer = new Date().getTime();
        },
        async renderFormList (model, isInitSearch, searchCondition) {
            this.searchParams.searchCondition = [];
            this.searchParams.modelId = model.dataModelId;
            this.searchParams.formId = model.dataFormId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.formPage.currentPage,
                pageSize: this.formPage.pageSize
            }, this.searchParams));
            if (formData.otherData && formData.otherData.tableColumns) {
                this.tableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        this.tableColumns.push(item);
                    }
                });
            }
            this.refreshSearchConditon(this.tableColumns);
            loading.close();
        }
    }
};
</script>

<style lang="less" scoped="scoped">
.bi-content {
    height: 99%;
    width: ~"calc(100% - 66px)";
    top: 0vh;
    overflow: auto;
    position: absolute;
    .bi-content-top{
        .opera-tit-btn{
            display: flex;
            height:6vh;
            line-height: 6vh;
            .tit{
                flex: 1;
                font-size: 1.25rem;
                font-weight: 400;
                text-align: left;
            }
            .btn{
                flex: 1;
                text-align: right;
            }
        }
        .form-data{
            .zb-item{
                display: flex;
                width: 480px;
                height: 40px;
                line-height: 40px;
                margin-left: 20px;
                float: left;
                border: 2px dashed #bbb5b5;
                margin-bottom: 6px;
                .item-field{
                   width:90px;
                   display: flex;
                   .field-name{
                       display: inline-block;
                       text-overflow: ellipsis;
                       white-space: nowrap;
                       overflow: hidden;
                       cursor: pointer;
                   }
                   .field-name-border{
                       display: inline-block;
                   }
                }
                .item-calcul{
                   width: 190px;
                }
                .item-alias{
                   width: 190px;
                }
            }
            .bi-type{
                display: flex;
                padding-left: 32px;
               .bi-type-item {
                   width: 58px;
                   height: 60px;
                   line-height: 60px;
                   float: left;
                   text-align: center;
                   .active {
                       border: 2px solid #009ed0;
                       border-radius: 2px;
                   }
                   .icon{
                       width: 36px;
                       height: 36px;
                       margin-top: 12px;
                       cursor: pointer;
                   }
                   .icon:hover{
                       width: 40px;
                       height: 40px;
                       margin-top: 10px;
                   }
               }
               .bi-tit{
                   width: 60px;
                   height: 60px;
                   line-height: 60px;
               }
               .bi-datasource-tit{
                   height: 60px;
                   line-height: 60px;
                   margin-left:20px;
               }
               .bi-datasource-data{
                   height: 60px;
                   line-height: 60px;
                   margin-left:20px;
               }
            }
        }
    }
    .bi-content-main{
        margin-top: 1vh;
    }
    /deep/ .search-field-box{
        height: 100% !important;
    }
}
.el-collapse-item__wrap{
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomBi/BiConfig.vue